<template>
  <div class="grid-x flex-grow edit-profile-mobile">
    <div
      class="cell auto cell-block-y flex flex-col flex-grow"
      v-if="payload">
      <div class="grid-x grid-padding-x py-6 px-2">
        <div class="cell auto flex flex-col space-y-6">
          <IwalyInput
            classes="bg-hint border-none"
            label="Телефон"
            placeholder=""
            :disabled="true"
            v-model="payload.phone"/>
          <div v-if="payload.businessType">
            <IwalyInput
              classes="bg-hint border-none"
              label="Тип правовой организации"
              placeholder="Выберите тип правовой организации"
              :disabled="true"
              v-model="payload.businessType.label"
              v-if="payload.legalInfo"/>
          </div>
          <div v-else>
            <IwalyInput
              classes="bg-hint border-none"
              label="Тип правовой организации"
              placeholder="Выберите тип правовой организации"
              :disabled="true"/>
          </div>
          <div
            class="position-relative">
            <IwalyInput
              label="ИНН"
              placeholder="Введите ИНН"
              v-model="payload.inn"/>
          </div>
          <div
            class="position-relative"
            v-if="payload.legalInfo && !individual">
            <IwalyInput
              :classes="$classnames(['bg-hint', {
                'border-hint':
                  !$v.payload.name.$dirty ||
                  !$v.payload.name.$invalid,
                'border-danger':
                  $v.payload.name.$dirty &&
                  $v.payload.name.$invalid,
              }])"
              label="Название компании"
              placeholder="Введите название компании"
              v-model="payload.name"/>
            <div
              class="flex flex-col mt-1 position-absolute"
              v-if="$v.payload.name.$dirty && $v.payload.name.$invalid">
              <small
                class="font-rubik text-danger"
                v-if="!$v.payload.name.required">Поле обязательно для заполнения</small>
            </div>
          </div>
          <div class="input-group">
            <label>Страна</label>
            <Select
              class="bg-hint"
              :options="countries"
              :label="'name'"
              placeholder="Выберите страну"
              v-model="payload.location.country"/>
          </div>
          <div class="position-relative">
            <div class="input-group">
              <label>Область</label>
              <Select
                :class="$classnames(['bg-hint', {
                  'border-hint':
                    !$v.payload.location.region.$dirty ||
                    !$v.payload.location.region.$invalid,
                  'border-danger':
                    $v.payload.location.region.$dirty &&
                    $v.payload.location.region.$invalid,
                }])"
                :options="allowedRegions"
                :label="'name'"
                placeholder="Выберите область"
                v-model="payload.location.region"/>
            </div>
            <div
              class="flex flex-col mt-1 position-absolute"
              v-if="$v.payload.location.region.$dirty && $v.payload.location.region.$invalid">
              <small
                class="font-rubik text-danger"
                v-if="!$v.payload.location.region.required">Поле обязательно для заполнения</small>
            </div>
          </div>
          <div class="position-relative">
            <div class="input-group">
              <label>Город / населённый пункт</label>
              <Select
                class="bg-hint"
                :options="districts"
                :label="'name'"
                :clearable="true"
                :searchable="true"
                :disabled="!payload.location.region"
                placeholder="Выберите город"
                v-model="payload.location.city"/>
            </div>
          </div>
          <div
            class="position-relative"
            v-if="payload.legalInfo && !individual">
            <IwalyInput
              :classes="$classnames(['bg-hint', {
                'border-hint':
                  !$v.payload.legalInfo.organization.address.$dirty ||
                  !$v.payload.legalInfo.organization.address.$invalid,
                'border-danger':
                  $v.payload.legalInfo.organization.address.$dirty &&
                  $v.payload.legalInfo.organization.address.$invalid,
              }])"
              label="Адрес"
              placeholder="Введите адрес"
              v-model="payload.legalInfo.organization.address"/>
            <div
              class="flex flex-col mt-1 position-absolute"
              v-if="
                $v.payload.legalInfo.organization.address.$dirty &&
                $v.payload.legalInfo.organization.address.$invalid
              ">
              <small
                class="font-rubik text-danger"
                v-if="!$v.payload.legalInfo.organization.address.required">
                  Поле обязательно для заполнения
              </small>
            </div>
          </div>
          <div
            class="position-relative"
            v-if="payload.legalInfo && llc">
            <IwalyInput
              :classes="$classnames(['bg-hint', {
                'border-hint':
                  !$v.payload.legalInfo.organization.ogrn.$dirty ||
                  !$v.payload.legalInfo.organization.ogrn.$invalid,
                'border-danger':
                  $v.payload.legalInfo.organization.ogrn.$dirty &&
                  $v.payload.legalInfo.organization.ogrn.$invalid,
              }])"
              label="ОГРН"
              placeholder="Укажите ОГРН"
              v-model="payload.legalInfo.organization.ogrn"/>
            <div
              class="flex flex-col mt-1 position-absolute"
              v-if="
                $v.payload.legalInfo.organization.ogrn.$dirty &&
                $v.payload.legalInfo.organization.ogrn.$invalid
              ">
              <small
                class="font-rubik text-danger"
                v-if="!$v.payload.legalInfo.organization.ogrn.required">
                  Поле обязательно для заполнения
              </small>
            </div>
          </div>
          <div
            class="position-relative"
            v-if="payload.legalInfo && llc">
            <IwalyInput
              :classes="$classnames(['bg-hint', {
                'border-hint':
                  !$v.payload.legalInfo.organization.kpp.$dirty ||
                  !$v.payload.legalInfo.organization.kpp.$invalid,
                'border-danger':
                  $v.payload.legalInfo.organization.kpp.$dirty &&
                  $v.payload.legalInfo.organization.kpp.$invalid,
              }])"
              label="КПП"
              placeholder="Укажите КПП"
              v-model="payload.legalInfo.organization.kpp"/>
            <div
              class="flex flex-col mt-1 position-absolute"
              v-if="
                $v.payload.legalInfo.organization.kpp.$dirty &&
                $v.payload.legalInfo.organization.kpp.$invalid
              ">
              <small
                class="font-rubik text-danger"
                v-if="!$v.payload.legalInfo.organization.kpp.required">
                  Поле обязательно для заполнения
              </small>
            </div>
          </div>
        </div>
        <div class="cell auto flex flex-col space-y-6">
          <div
            class="position-relative"
            v-if="payload.legalInfo && !individual">
            <IwalyInput
              :classes="$classnames(['bg-hint', {
                'border-hint':
                  !$v.payload.legalInfo.organization.contactName.$dirty ||
                  !$v.payload.legalInfo.organization.contactName.$invalid,
                'border-danger':
                  $v.payload.legalInfo.organization.contactName.$dirty &&
                  $v.payload.legalInfo.organization.contactName.$invalid,
              }])"
              label="ФИО контактного лица"
              placeholder="Введите ФИО контактного лица"
              v-model="payload.legalInfo.organization.contactName"/>
            <div
              class="flex flex-col mt-1 position-absolute"
              v-if="
                $v.payload.legalInfo.organization.contactName.$dirty &&
                $v.payload.legalInfo.organization.contactName.$invalid
              ">
              <small
                class="font-rubik text-danger"
                v-if="!$v.payload.legalInfo.organization.contactName.required">
                  Поле обязательно для заполнения
              </small>
            </div>
          </div>
          <div
            class="position-relative"
            v-if="payload.legalInfo && !individual">
            <IwalyInput
              :classes="$classnames(['bg-hint', {
                'border-hint':
                  !$v.payload.legalInfo.organization.contactPhone.$dirty ||
                  !$v.payload.legalInfo.organization.contactPhone.$invalid,
                'border-danger':
                  $v.payload.legalInfo.organization.contactPhone.$dirty &&
                  $v.payload.legalInfo.organization.contactPhone.$invalid,
              }])"
              label="Контактный телефон"
              placeholder="Введите контактный телефон"
              v-model="payload.legalInfo.organization.contactPhone"/>
            <div
              class="flex flex-col mt-1 position-absolute"
              v-if="
                $v.payload.legalInfo.organization.contactPhone.$dirty &&
                $v.payload.legalInfo.organization.contactPhone.$invalid
              ">
              <small
                class="font-rubik text-danger"
                v-if="!$v.payload.legalInfo.organization.contactPhone.required">
                  Поле обязательно для заполнения
              </small>
            </div>
          </div>
          <div class="position-relative">
            <IwalyInput
              :classes="$classnames(['bg-hint', {
                'border-hint':
                  !isChangeRequest &&
                  (!$v.payload.email.$dirty ||
                  !$v.payload.email.$invalid),
                'border-primary':
                  isChangeRequest &&
                  (!$v.payload.email.$dirty ||
                  !$v.payload.email.$invalid),
                'border-danger':
                  $v.payload.email.$dirty &&
                  $v.payload.email.$invalid,
                'bg-hint':
                  !isChangeRequest ||
                  ($v.payload.email.$dirty ||
                  $v.payload.email.$invalid),
                'bg-primary-light':
                  isChangeRequest &&
                  (!$v.payload.email.$dirty ||
                  !$v.payload.email.$invalid),
              }])"
              label="E-mail"
              placeholder="Введите e-mail"
              v-model="payload.email">
              <template v-slot:label="{ label }">
                <label class="flex flex-row items-center">
                  {{ label }}
                  <img
                    v-if="payload.emailVerified"
                    class="w-3 ml-2"
                    src="@/assets/icons/ok.svg"
                    alt="">
                </label>
              </template>
            </IwalyInput>
            <div
              class="flex flex-col mt-1 position-absolute"
              v-if="
                $v.payload.email.$dirty &&
                $v.payload.email.$invalid
              ">
              <small
                class="font-rubik text-danger"
                v-if="!$v.payload.email.required">
                  Поле обязательно для заполнения
              </small>
            </div>
          </div>
          <div class="position-relative">
            <IwalyInput
              type="number"
              :classes="$classnames(['bg-hint', {
                'border-hint':
                  !isChangeRequest &&
                  (!$v.payload.maxActiveOrders.$dirty ||
                  !$v.payload.maxActiveOrders.$invalid),
                'border-primary':
                  isChangeRequest &&
                  (!$v.payload.maxActiveOrders.$dirty ||
                  !$v.payload.maxActiveOrders.$invalid),
                'border-danger':
                  $v.payload.maxActiveOrders.$dirty &&
                  $v.payload.maxActiveOrders.$invalid,
                'bg-hint':
                  !isChangeRequest ||
                  ($v.payload.maxActiveOrders.$dirty ||
                  $v.payload.maxActiveOrders.$invalid),
                'bg-primary-light':
                  isChangeRequest &&
                  (!$v.payload.maxActiveOrders.$dirty ||
                  !$v.payload.maxActiveOrders.$invalid),
              }])"
              label="Максимальное количество заказов"
              placeholder="Введите максимальное количество заказов"
              v-model="payload.maxActiveOrders" />
            <div
              class="flex flex-col mt-1 position-absolute"
              v-if="
                $v.payload.maxActiveOrders.$dirty &&
                $v.payload.maxActiveOrders.$invalid
              ">
              <small
                class="font-rubik text-danger"
                v-if="!$v.payload.maxActiveOrders.required">
                Поле обязательно для заполнения
              </small>
            </div>
          </div>
          <div
            class="position-relative"
            v-if="payload.legalInfo && individual">
          </div>
          <div
            class="input-group"
            v-if="payload.legalInfo && !individual">
            <label>Система налогообложения</label>
            <Select
              class="bg-hint"
              :options="taxSystems"
              :value="payload.taxSystem"
              @input="($event) => payload.taxSystem = $event"
              placeholder="Выберите систему налогообложения"/>
          </div>
          <div
            class="position-relative"
            v-if="payload.legalInfo && !individual">
            <IwalyInput
              :classes="$classnames(['bg-hint', {
                'border-hint':
                  !isChangeRequest &&
                  (!$v.payload.legalInfo.organization.bankCode.$dirty ||
                  !$v.payload.legalInfo.organization.bankCode.$invalid),
                'border-primary':
                  isChangeRequest &&
                  (!$v.payload.legalInfo.organization.bankCode.$dirty ||
                  !$v.payload.legalInfo.organization.bankCode.$invalid),
                'border-danger':
                  $v.payload.legalInfo.organization.bankCode.$dirty &&
                  $v.payload.legalInfo.organization.bankCode.$invalid,
                'bg-hint':
                  !isChangeRequest ||
                  ($v.payload.legalInfo.organization.bankCode.$dirty ||
                  $v.payload.legalInfo.organization.bankCode.$invalid),
                'bg-primary-light':
                  isChangeRequest &&
                  (!$v.payload.legalInfo.organization.bankCode.$dirty ||
                  !$v.payload.legalInfo.organization.bankCode.$invalid),
              }])"
              label="БИК банка"
              placeholder="Введите БИК банка"
              v-model="payload.legalInfo.organization.bankCode"/>
            <div
              class="flex flex-col mt-1 position-absolute"
              v-if="
                $v.payload.legalInfo.organization.bankCode.$dirty &&
                $v.payload.legalInfo.organization.bankCode.$invalid
              ">
              <small
                class="font-rubik text-danger"
                v-if="!$v.payload.legalInfo.organization.bankCode.required">
                  Поле обязательно для заполнения
              </small>
            </div>
          </div>
          <div
            class="position-relative"
            v-if="payload.legalInfo && !individual">
            <IwalyInput
              :classes="$classnames(['bg-hint', {
                'border-hint':
                  !isChangeRequest &&
                  (!$v.payload.legalInfo.organization.bankAccount.$dirty ||
                  !$v.payload.legalInfo.organization.bankAccount.$invalid),
                'border-primary':
                  isChangeRequest &&
                  (!$v.payload.legalInfo.organization.bankAccount.$dirty ||
                  !$v.payload.legalInfo.organization.bankAccount.$invalid),
                'border-danger':
                  $v.payload.legalInfo.organization.bankAccount.$dirty &&
                  $v.payload.legalInfo.organization.bankAccount.$invalid,
                'bg-hint':
                  !isChangeRequest ||
                  ($v.payload.legalInfo.organization.bankAccount.$dirty ||
                  $v.payload.legalInfo.organization.bankAccount.$invalid),
                'bg-primary-light':
                  isChangeRequest &&
                  (!$v.payload.legalInfo.organization.bankAccount.$dirty ||
                  !$v.payload.legalInfo.organization.bankAccount.$invalid),
              }])"
              label="Р/С"
              placeholder="Введите Р/С"
              v-model="payload.legalInfo.organization.bankAccount"/>
            <div
              class="flex flex-col mt-1 position-absolute"
              v-if="
                $v.payload.legalInfo.organization.bankAccount.$dirty &&
                $v.payload.legalInfo.organization.bankAccount.$invalid
              ">
              <small
                class="font-rubik text-danger"
                v-if="!$v.payload.legalInfo.organization.bankAccount.required">
                  Поле обязательно для заполнения
              </small>
            </div>
          </div>
          <div
            class="position-relative"
            v-if="payload.legalInfo && !individual">
            <IwalyInput
              :classes="$classnames(['bg-hint', {
                'border-hint':
                  !isChangeRequest &&
                  (!$v.payload.legalInfo.organization.managerName.$dirty ||
                  !$v.payload.legalInfo.organization.managerName.$invalid),
                'border-primary':
                  isChangeRequest &&
                  (!$v.payload.legalInfo.organization.managerName.$dirty ||
                  !$v.payload.legalInfo.organization.managerName.$invalid),
                'border-danger':
                  $v.payload.legalInfo.organization.managerName.$dirty &&
                  $v.payload.legalInfo.organization.managerName.$invalid,
                'bg-hint':
                  !isChangeRequest ||
                  ($v.payload.legalInfo.organization.managerName.$dirty ||
                  $v.payload.legalInfo.organization.managerName.$invalid),
                'bg-primary-light':
                  isChangeRequest &&
                  (!$v.payload.legalInfo.organization.managerName.$dirty ||
                  !$v.payload.legalInfo.organization.managerName.$invalid),
              }])"
              label="ФИО подписанта"
              placeholder="Введите ФИО подписанта"
              v-model="payload.legalInfo.organization.managerName"/>
            <div
              class="flex flex-col mt-1 position-absolute"
              v-if="
                $v.payload.legalInfo.organization.managerName.$dirty &&
                $v.payload.legalInfo.organization.managerName.$invalid
              ">
              <small
                class="font-rubik text-danger"
                v-if="!$v.payload.legalInfo.organization.managerName.required">
                  Поле обязательно для заполнения
              </small>
            </div>
          </div>
        </div>
        <div class="cell auto flex flex-col space-y-6">
          <!-- <IwalyInput
            classes="bg-hint border-none"
            label="Комиссия сервиса"
            placeholder="Введите комиссию сервиса"/> -->
          <div class="position-relative">
            <IwalyInput
              classes="bg-hint border-none"
              label="Комментарий регистрации"
              placeholder="Комментарий из формы регистрации"
              :textarea="true"
              :rows="4"
              v-model="payload.registrationComment"/>
          </div>
          <div class="grid-y space-y-2">
            <div class="cell">
              <span class="text-14px leading-16px text-muted">Услуги</span>
            </div>
            <div class="cell flex flex-col space-y-2">
              <Check
                :label="$delve(category, 'name')"
                :value="payload.serviceCategories.includes(category.id)"
                :key="index"
                @input="($event) => setCategory(category, $event)"
                v-for="(category, index) in serviceCategories"/>
            </div>
          </div>
          <div class="flex flex-row flex-grow items-end space-x-2">
            <button
              class="btn btn-xs btn-outline-primary flex-grow"
              @click="$router.back()">Отмена</button>
            <button
              v-if="!$wait.is('fetch.service.categories')"
              class="btn btn-xs btn-primary flex-grow"
              @click="save">Сохранить</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import { mapGetters, mapActions, mapState } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import IwalyInput from '@/components/Input.vue';
import Check from '@/components/Check.vue';
import Select from '@/components/Select.vue';

export default {
  props: {
    value: {
      type: Object,
      validator: (obj) => typeof obj === 'object' || obj === null,
    },
  },
  components: {
    IwalyInput,
    Check,
    Select,
  },
  data() {
    return {
      payload: null,
    };
  },
  validations() {
    if (this.payload.legalInfo && !this.individual) {
      if (this.llc) {
        return {
          payload: {
            inn: { required },
            name: { required },
            email: { required },
            maxActiveOrders: { required },
            location: {
              region: { required },
            },
            legalInfo: {
              organization: {
                address: { required },
                ogrn: { required },
                kpp: { required },
                contactName: { required },
                contactPhone: { required },
                bankCode: { required },
                bankAccount: { required },
                managerName: { required },
              },
            },
          },
        };
      }
      return {
        payload: {
          inn: { required },
          name: { required },
          email: { required },
          maxActiveOrders: { required },
          location: {
            region: { required },
          },
          legalInfo: {
            organization: {
              address: { required },
              ogrn: { required },
              contactName: { required },
              contactPhone: { required },
              bankCode: { required },
              bankAccount: { required },
              managerName: { required },
            },
          },
        },
      };
    }
    /** Правила валидации для самозанятых */
    return {
      payload: {
        email: { required },
        phone: { required },
        maxActiveOrders: { required },
        location: {
          region: { required },
        },
        legalInfo: {
          individual: {},
        },
      },
    };
  },
  computed: {
    ...mapState({
      individualRegions: (state) => state.settings.individualRegions,
    }),
    ...mapGetters({
      enumsGetter: 'settings/selectEnums',
      regionsGetter: 'settings/regions',
      districtsGetter: 'settings/districts',
      serviceCategories: 'services/activeServiceCategories',
    }),
    ...mapState({
      countries: (state) => state.settings.countries,
    }),
    legalTypes() {
      return this.enumsGetter('legalType');
    },
    taxSystems() {
      return this.enumsGetter('taxSystem');
    },
    regions() {
      const country = _.get(this.payload, 'location.country.id');
      if (country) {
        return this.regionsGetter(country);
      }
      return [];
    },
    districts() {
      const region = _.get(this.payload, 'location.region.id');
      if (region) {
        return this.districtsGetter(region);
      }
      return [];
    },
    allowedRegions() {
      if (this.individual) {
        return this.regions.filter((region) => this.individualRegions.includes(region.id));
      }
      return this.regions;
    },
    llc() {
      return _.get(this.payload, 'businessType.value') === 'llc';
    },
    individual() {
      return _.get(this.payload, 'businessType.value') === 'individual';
    },
    isRegistrationRequest() {
      if (!this.value) return false;
      return !this.value.registered && !this.value.verified;
    },
    isChangeRequest() {
      if (!this.value) return false;
      return !!this.value.registered && !this.value.verified;
    },
  },
  methods: {
    ...mapActions({
      fetchRegions: 'settings/ACT_FETCH_REGIONS',
      fetchDistricts: 'settings/ACT_FETCH_DISTRICTS',
    }),
    setCategory(category) {
      this.payload.serviceCategories = _.xor(this.payload.serviceCategories, [category.id]);
    },
    fetchRegionDistricts(regionId) {
      if (!regionId) {
        return Promise.resolve([]);
      }

      return this.fetchDistricts(regionId).then(() => this.districts);
    },
    ensureSelectedCity() {
      const cityId = _.get(this.payload, 'cityId');
      const cityName = _.get(this.payload, 'city');
      const selectedCityId = _.get(this.payload, 'location.city.id');

      if (selectedCityId || !cityId) {
        return;
      }

      const found = _.find(this.districts, (district) => parseInt(district.id, 10) === parseInt(cityId, 10));
      if (found) {
        this.payload.location.city = found;
        return;
      }

      if (cityName) {
        this.payload.location.city = {
          id: cityId,
          name: cityName,
        };
      }
    },
    resetCityIfRegionChanged() {
      const cityId = _.get(this.payload, 'location.city.id');
      if (!cityId) {
        return;
      }

      const found = _.find(this.districts, (district) => parseInt(district.id, 10) === parseInt(cityId, 10));
      if (!found) {
        this.payload.location.city = null;
        this.payload.cityId = null;
        this.payload.city = '';
      }
    },
    getPayload() {
      let { legalInfo } = this.payload;
      const { businessType } = this.payload;
      if (legalInfo) {
        if (businessType.value === 'individual') {
          legalInfo = {
            type: 'individual',
            individual: {
              ...legalInfo.individual,
            },
          };
        } else {
          legalInfo = {
            type: 'organization',
            organization: {
              ...legalInfo.organization,
              taxSystem: _.get(this.payload.taxSystem, 'value'),
            },
          };
        }
      }
      return {
        legalInfo,
        phone: this.payload.phone,
        region: _.get(this.payload, 'location.region.id'),
        cityId: _.get(this.payload, 'location.city.id') || null,
        city: _.get(this.payload, 'location.city.name') || this.payload.city || '',
        registrationComment: this.payload.registrationComment || null,
        inn: this.payload.inn,
        name: this.payload.name,
        email: this.payload.email,
        maxActiveOrders: +this.payload.maxActiveOrders,
        serviceCategories: this.payload.serviceCategories.filter((catId) => _.find(
          this.serviceCategories,
          (activeCategory) => activeCategory.id === catId,
        )),
      };
    },
    save() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.$emit('save', this.getPayload());
      }
    },
  },
  watch: {
    value: {
      handler(value) {
        if (value) {
          this.payload = value;
        }
      },
      immediate: true,
      deep: true,
    },
    'payload.location.country': {
      handler(value) {
        const id = _.get(value, 'id');
        if (id) {
          this.fetchRegions(id).then((response) => {
            const found = _.find(
              response,
              (region) => region.id === _.get(this.payload.location.region, 'id'),
            );
            if (!found) {
              this.payload.location.region = null;
              this.payload.location.city = null;
            }
          });
        }
      },
      deep: true,
    },
    'payload.location.region': {
      handler(value, oldValue) {
        const id = _.get(value, 'id');
        const oldId = _.get(oldValue, 'id');
        if (!id) {
          if (this.payload && this.payload.location) {
            this.payload.location.city = null;
          }
          return;
        }

        this.fetchRegionDistricts(id).then(() => {
          if (oldId && id !== oldId) {
            this.resetCityIfRegionChanged();
          } else {
            this.ensureSelectedCity();
          }
        });
      },
      deep: true,
      immediate: true,
    },
    'payload.location.city': {
      handler(value) {
        if (!this.payload) {
          return;
        }

        this.payload.cityId = _.get(value, 'id') || null;
        this.payload.city = _.get(value, 'name') || '';
      },
      deep: true,
    },
  },
};
</script>
